export default __webpack_public_path__ + "static/media/HIW-val-2.a708e7e5.webp";